define((require) => {
    "use strict";

    const _           = require("underscore");
    const EffectModel = require("shared/ui/experience/action/effects/EffectModel");

    const TYPE = "opacity";

    return EffectModel.extend({
        defaults: _.defaults({
            type: TYPE,
            opacity: 0.5
        }, EffectModel.prototype.defaults)
    }, {
        TYPE
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/OpacityEffectModel.js